import { atom } from "recoil";

export const confirmStateAtom = atom({
  key: "confirmState",
  default: {
    isOpen: false,
    header: "",
    content: "",
    cancelButtonText: "Annuler",
    confirmButtonText: "Confirmer",
    onCancel: () => {},
    onConfirm: () => {},
  },
});
